import { Controller } from "stimulus"
import { arpu_validateEmail } from "../packs/arpu_utils.js"

export default class extends Controller {
  static targets = ["email", "inputData", "confirmData", "displayEmailOptions" , "emailOption", "result", "resultText"]

  static values = {
    url: String
  }

  newRequest() {
    this.resultTarget.hidden = true
    this.confirmDataTarget.hidden = true
    this.inputDataTarget.hidden = false
  }

  confirmEmail() {
    this.confirmDataTarget.hidden = false
    this.inputDataTarget.hidden = true

    const email = this.emailTarget.value.trim()
    this.buildRadioOptions(email)
  }

  buildRadioOptions(email) {
    const emailOptions = [ email, 'AgentKay@getarpu.com', 'James.Edwards@getarpu.com', 'Laurel.Weaver@getarpu.com']

    let html = '<p>Please select one of the following email addresses to confirm:</p>'
    emailOptions.sort(() => Math.random() - 0.5).forEach((option, index) => {
      html += `
	<div>
	  <input type="radio" data-gdpr-request-target="emailOption" id="emailOption${index}" name="emailOptions" value="${option}">
	  <label style="display: inline" for="emailOption${index}">${option}</label>
	</div>
      `
    })
    this.displayEmailOptionsTarget.innerHTML = html
  }

  displayResponse(message) {
    this.confirmDataTarget.hidden = true
    this.inputDataTarget.hidden = true
    this.resultTextTarget.innerHTML = message
    this.resultTarget.hidden = false
  }

  getSelectedEmail() {
    const emailOptions = this.emailOptionTargets
    for (let i = 0; i < emailOptions.length; i++) {
      if (emailOptions[i].checked) {
	return emailOptions[i].value
      }
    }
    return null
  }

  commitGdpr() {
    const selectedEmail = this.getSelectedEmail();
    const email = this.emailTarget.value.trim()

    if(selectedEmail != email) {
      this.displayResponse('👽 MIB agents are not real.<br> Please select the real email address next time!')
      return
    }

    let formData = new FormData()
    formData.append('email', email)

    fetch(this.urlValue, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.head.querySelector("[name~=csrf-token][content]").content
      }
    })
    .then(response => {
      if (response.ok) {
        response.json().then(data => {
          this.responseOk(data)
          this.emailTarget.value = ''
        })
      }
      else {
        response.json().then(data => {
          this.responseError(data)
        })
      }
    })
    .catch(error => {
      this.responseError('Error: ' + error)
    })
  }

  responseOk(data) {
    console.log(data)
    this.displayResponse('✅ ' + data.message)
  }

  responseError(data) {
    console.log(data)
    this.displayResponse('🙈 ' + data.message)
  }

}
